import { useEffect, useState } from 'react';
import { IoChevronDown } from 'react-icons/io5';
import { useSwiper } from 'swiper/react';

export function SlideNextButton({ controller, disabled = false }) {
	const swiper = useSwiper();
	const [controls, setControls] = useState(controller);

	useEffect(() => {
		setControls(controller)
	}, [controller])

	return (
		<button className='slide-next' disabled={disabled} onClick={() => controls ? controls.slideNext() : swiper?.slideNext()}>
			<IoChevronDown />
		</button>
	);
}